import WykonajScreen from './WykonajScreen';
export default WykonajScreen;